import {DisclosurePageRef, EngagementId} from "platformed-client/types";
import api from "../../../api";
import {param, typedQuery} from "../../typing";

export const disclosureSummary = typedQuery(
  ["tprm", "disclosureSummary", param<EngagementId>("engagementId")],
  async engagementId => {
    return await api.tprm.disclosures.summary(engagementId);
  },
);

export const disclosurePageActivityStream = typedQuery(
  ["tprm", "disclosurePageActivityStream", param<EngagementId>("engagementId"), param<DisclosurePageRef>("page")],
  async (engagementId, page) => {
    return await api.tprm.disclosures.openPageActivityStream(engagementId, page);
  },
);
